<template>
  <div class="flex gap-3">
    <Button as-child variant="outline" class="cursor-pointer group" data-track="clicked-edit-teammate-button">
      <router-link :to="`${route.fullPath}/edit`">
        <vue-feather type="edit-2" class="icon" />
        Edit
      </router-link>
    </Button>
    <Button
      v-if="record.status == 'Active'"
      variant="outline"
      class="cursor-pointer group"
      data-track="clicked-deactivate-teammate-button"
      @click="showContactDeactivate = true"
    >
      <vue-feather type="alert-triangle" class="icon" />
      Deactivate
    </Button>
    <Button
      v-else-if="record.status == 'Inactive'"
      variant="outline"
      class="cursor-pointer group"
      data-track="clicked-activate-teammate-button"
      @click="showContactActivate = true"
    >
      <vue-feather type="check" class="icon" />
      Activate
    </Button>

    <TeammateActivate v-if="showContactActivate" @handle-contact-activate-cancel="showContactActivate = false" />
    <TeammateDeactivate
      v-if="showContactDeactivate"
      @handle-contact-deactivate-cancel="showContactDeactivate = false"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { Button } from '@/components/ui/button';
import TeammateActivate from './TeammateActivate.vue';
import TeammateDeactivate from './TeammateDeactivate.vue';

defineProps<{
  record: { status: string };
}>();

const route = useRoute();

const showContactActivate = ref(false);
const showContactDeactivate = ref(false);
</script>

<style scoped>
@reference "tailwindcss";

.icon {
  @apply h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500;
}
</style>
